import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Resolver } from '../../../core/components';
import { PageLoading } from '../../../common/components/styled';
import { DocumentTitle } from '../../../common/components';
import { SOLD } from '../../../quote/constants';
import { loadOpportunity } from '../../ducks';
import SoldOpportunityDetailsPage from './SoldOpportunityDetailsPage';

class SoldOpportunityDetailsPageResolver extends PureComponent {
  resolve = () => {
    const { match, loadOpportunity } = this.props;
    const { quoteId } = match.params;
    return loadOpportunity(quoteId, SOLD);
  };

  render() {
    return (
      <>
        <DocumentTitle>Status tracker</DocumentTitle>
        <Resolver successComponent={SoldOpportunityDetailsPage} loadingComponent={PageLoading} resolve={this.resolve} />
      </>
    );
  }
}

SoldOpportunityDetailsPageResolver.propTypes = {
  loadOpportunity: PropTypes.func.isRequired,
  match: RouterPropTypes.match.isRequired,
};

const mapDispatchToProps = { loadOpportunity };

export default withRouter(
  connect(
    undefined,
    mapDispatchToProps,
  )(SoldOpportunityDetailsPageResolver),
);
